/**
 * Accounting periods, year-end close, and the one fiscal-year setting behind both.
 *
 * Ids issued by the central key service on 21 September 2026 — the same numbers
 * the backend migration writes as each permission row's id, so the two must stay
 * equal. Read an issued id, never derive the next one from the last.
 */

// The posting lock: the date ranges the office has declared finished.
export const ACCOUNTING_PERIODS_INDEX = 1647;
export const ACCOUNTING_PERIODS_CREATE = 1648;
export const ACCOUNTING_PERIODS_UPDATE = 1649;
/**
 * Closing and reopening are their own keys rather than `update`: they are the two
 * decisions an auditor asks about, and a role that renames a period is not
 * necessarily one that may unlock a month.
 */
export const ACCOUNTING_PERIODS_CLOSE = 1650;
export const ACCOUNTING_PERIODS_REOPEN = 1632;

// The event: the journal that swept a year's result into Retained Earnings.
export const FISCAL_YEAR_CLOSINGS_INDEX = 1633;
export const FISCAL_YEAR_CLOSINGS_CLOSE = 1634;
export const FISCAL_YEAR_CLOSINGS_REOPEN = 1635;

/**
 * Changing which month the office's financial year opens on.
 *
 * An `agent_options.*` key, so it would read as a settings permission — it lives
 * here because the month is not a preference about a screen: it is what the
 * year-end close resolves its twelve-month window from, and the settings panel
 * gated on it is this module's panel rendered inside Settings.
 *
 * Reading the setting is offered on this key OR `fiscal_year_closings.index`
 * (the route's `permission:` middleware is variadic), which is why the closings
 * register can show the window without holding this one.
 */
export const AGENT_OPTIONS_UPDATE_FISCAL_YEAR = 1636;
